<template>
  <div class="SkeletonSearchResult">
    <div class="SkeletonSearchResult--image">
      <ai-skeleton
        desktop-width="445px"
        desktop-height="280px"
        mobile-width="295px"
        mobile-height="196px" />
    </div>

    <div class="SkeletonSearchResult--informations">
      <ai-skeleton
        desktop-width="110px"
        desktop-height="34px"
        mobile-width="110px"
        mobile-height="34px" />
      <ai-skeleton
        desktop-width="230px"
        desktop-height="24px"
        mobile-width="230px"
        mobile-height="24px" />
      <ai-skeleton
        desktop-width="160px"
        desktop-height="12px"
        mobile-width="160px"
        mobile-height="12px" />

      <div class="SkeletonSearchResult--icons">
        <ai-skeleton
          desktop-width="40px"
          desktop-height="40px"
          mobile-width="24px"
          mobile-height="24px" />
        <ai-skeleton
          desktop-width="40px"
          desktop-height="40px"
          mobile-width="24px"
          mobile-height="24px" />
      </div>

      <ai-skeleton
        desktop-width="210px"
        desktop-height="12px"
        mobile-width="0px"
        mobile-height="0px" />
    </div>

    <div class="SkeletonSearchResult--actions">
      <ai-skeleton
        desktop-width="160px"
        desktop-height="16px"
        mobile-width="160px"
        mobile-height="12px" />
      <ai-skeleton
        desktop-width="70px"
        desktop-height="12px"
        mobile-width="90px"
        mobile-height="12px" />
      <ai-skeleton
        desktop-width="160px"
        desktop-height="12px"
        mobile-width="170px"
        mobile-height="22px" />
      <ai-skeleton
        desktop-width="160px"
        desktop-height="12px"
        mobile-width="190px"
        mobile-height="22px" />
      <ai-skeleton
        desktop-width="278px"
        desktop-height="48px"
        mobile-width="295px"
        mobile-height="48px" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/mixins';
@use '@/assets/styles/utilities/functions' as func;

.SkeletonSearchResult {
  background: colors.$white;
  display: grid;
  padding: constants.$padding-01;
  grid-template-columns: 1fr;
  margin-bottom: constants.$margin-01;

  @media (mq.$from-large) {
    padding: constants.$padding-03;
    grid-template-columns: 4fr 5fr 3fr;
  }
}
.SkeletonSearchResult--informations {
  display: flex;
  flex-direction: column;
  margin-top: constants.$margin-02;

  @media (mq.$from-large) {
    margin-top: 0;
    margin-left: constants.$margin-02;
    @include mixins.rem-fallback(max-width, 485);
  }
}

.SkeletonSearchResult--image {
  @include mixins.rem-fallback(height, 196);

  @media (mq.$from-large) {
    @include mixins.rem-fallback(height, 280);
  }
}

.SkeletonSearchResult--icons {
  display: flex;
  flex-direction: row;

  & > div {
    margin-right: constants.$margin-00;
  }

  @media (mq.$from-large) {
    margin-top: func.calcRem(76);
  }
}

.SkeletonSearchResult--actions {
  display: flex;
  flex-direction: column;
  margin-top: constants.$margin-05;

  @media (mq.$from-large) {
    margin-top: 0;
    gap: constants.$inner-03;
    justify-content: end;
    align-items: flex-end;
    text-align: end;
  }
}
</style>
